import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { GenericSelect } from '../../components';


const PremiumWithdrawalPercentOfInput: InputWithSource = ({ input }) => (
    <GenericSelect label={input.name} input={input} />
);

PremiumWithdrawalPercentOfInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(PremiumWithdrawalPercentOfInput);
